import { createSlice } from '@reduxjs/toolkit'

export const shippingModalSlice = createSlice({
  name: 'shippingModal',
  initialState: {
    show: false,
  },
  reducers: {
    showShippingModal: (state, action) => {
      state.show = true;
    },
    hideShippingModal: (state) => {
      state.show = false;
    }
  },
})

export const { showShippingModal, hideShippingModal } = shippingModalSlice.actions

export default shippingModalSlice.reducer
